'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pubsub = require('../../pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _inputField = require('../input-field/input-field.scss');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputWithSelect = require('./input-with-select.scss');

var _inputWithSelect2 = _interopRequireDefault(_inputWithSelect);

var _inchParser = require('./../../../server/models/inch-pound/lib/inch-parser');

var _inchParser2 = _interopRequireDefault(_inchParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var parseInchString = (0, _inchParser2.default)().parseInchString;

var tempSelectVals = [{ key: '', label: '-' }, { key: '1/32', label: '1/32' }, { key: '1/16', label: '1/16' }, { key: '3/32', label: '3/32' }, { key: '1/8', label: '1/8' }, { key: '5/32', label: '5/32' }, { key: '3/16', label: '3/16' }, { key: '7/32', label: '7/32' }, { key: '1/4', label: '1/4' }, { key: '9/32', label: '9/32' }, { key: '5/16', label: '5/16' }, { key: '11/32', label: '11/32' }, { key: '3/8', label: '3/8' }, { key: '13/32', label: '13/32' }, { key: '7/16', label: '7/16' }, { key: '15/32', label: '15/32' }, { key: '1/2', label: '1/2' }, { key: '17/32', label: '17/32' }, { key: '9/16', label: '9/16' }, { key: '19/32', label: '19/32' }, { key: '5/8', label: '5/8' }, { key: '21/32', label: '21/32' }, { key: '11/16', label: '11/16' }, { key: '23/32', label: '23/32' }, { key: '3/4', label: '3/4' }, { key: '25/32', label: '25/32' }, { key: '13/16', label: '13/16' }, { key: '27/32', label: '27/32' }, { key: '7/8', label: '7/8' }, { key: '29/32', label: '29/32' }, { key: '15/16', label: '15/16' }, { key: '31/32', label: '31/32' }];

function parseRangeValue(string) {
    var tmpArray = ('' + string).split(' '); // convert input to string and split by whitespace

    if (tmpArray.length === 2) return parseInt(tmpArray[0]); // if there are two parts [0] is the numeric value
    if (tmpArray[0].indexOf('/') === -1) return parseInt(tmpArray[0]); // if there is no / index=0 is the numeric value

    return 0; // the minimum is a fractional so the numeric value is 0
}

var InputWithSelect = function (_React$Component) {
    _inherits(InputWithSelect, _React$Component);

    function InputWithSelect(props) {
        _classCallCheck(this, InputWithSelect);

        var _this = _possibleConstructorReturn(this, (InputWithSelect.__proto__ || Object.getPrototypeOf(InputWithSelect)).call(this, props));

        _this.parser = parseInchString;

        _this.state = {
            isBadgeActive: false,
            value: '',
            value_1: '',
            value_2: '',
            selectValues: tempSelectVals
        };

        _this.onMouseover = _this.onMouseover.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.handleValue = _this.handleValue.bind(_this);
        _this.setValue = _this.setValue.bind(_this);
        return _this;
    }

    _createClass(InputWithSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.value && typeof this.props.value === 'string') {
                var valueArray = this.props.value.split(' ');

                if (valueArray.length === 2) {
                    this.setState(function (prev) {
                        prev.value_1 = valueArray[0];
                        prev.value_2 = valueArray[1];

                        return prev;
                    });
                } else if (valueArray.length === 1) {
                    if (valueArray[0].indexOf('/') === -1) {
                        this.setState(function (prev) {
                            prev.value_1 = valueArray[0];

                            return prev;
                        });
                    } else {
                        this.setState(function (prev) {
                            prev.value_2 = valueArray[0];

                            return prev;
                        });
                    }
                }
            }

            if (this.props.showBadge) {
                this.badgeEventId = _pubsub2.default.on('input.badge-select', function (badgeName) {
                    if (badgeName !== _this2.props.name) {
                        _this2.setState({
                            isBadgeActive: false
                        });
                    }
                });

                this.graphEventId = _pubsub2.default.on('graph-display.nav-click', function () {
                    _this2.setState({
                        isBadgeActive: false
                    });
                });
            }

            if (this.props.filterSelectToMinMax) {
                this.setState(function (prev) {
                    prev.selectValues = filterSelectValues(tempSelectVals, _this2.props);

                    return prev;
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            // Remove subscriptions
            if (this.badgeEventId) {
                _pubsub2.default.off(this.badgeEventId);
            }

            if (this.graphEventId) {
                _pubsub2.default.off(this.graphEventId);
            }
        }
    }, {
        key: 'activateBadge',
        value: function activateBadge() {
            var _this3 = this;

            if (this.badgeEventId !== undefined) {
                this.setState({
                    isBadgeActive: true
                }, function () {
                    _pubsub2.default.trigger('input.badge-select', _this3.props.name);
                });
            }
        }
    }, {
        key: 'onMouseover',
        value: function onMouseover() {
            this.activateBadge();
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            this.activateBadge();
        }

        /**
         * Internal
         * @param e
         */

    }, {
        key: 'handleValue',
        value: function handleValue(e) {
            var _this4 = this;

            e.persist();
            var target = e.target;

            if (e.target.type === 'number') {
                this.setState({ value_1: target.value }, function () {
                    _this4.setValue(e);
                });
            } else {
                this.setState({ value_2: target.value }, function () {
                    e.target.addEventListener('blur', function () {
                        var elem = document.getElementById(e.target.id.replace('select', 'input'));
                        if (elem.checkValidity()) {
                            var event = void 0;

                            if (typeof Event === 'function') {
                                event = new Event('valid');
                            } else {
                                event = document.createEvent('Event');
                                event.initEvent('valid', true, true);
                            }
                            elem.dispatchEvent(event);
                        }
                    });

                    e.target = document.getElementById(e.target.id.replace('select', 'input'));

                    _this4.setValue(e);
                });
            }
        }

        /**
         * update value and bubble it up
         *
         * @param e
         */

    }, {
        key: 'setValue',
        value: function setValue(e) {
            var localMin = void 0,
                localMax = void 0;

            var _props$range = this.props.range,
                min = _props$range.min,
                max = _props$range.max;


            if (min) localMin = this.parser(min + '"');
            if (max) localMax = this.parser(max + '"');

            e.target.setCustomValidity('');

            var parsedValue = this.parser(this.state.value_1 + ' ' + this.state.value_2);

            if (min && parsedValue < localMin) e.target.setCustomValidity('out of range');
            if (max && parsedValue > localMax) e.target.setCustomValidity('out of range');

            e.target.internalValue = (this.state.value_1 + ' ' + this.state.value_2).trim();
            e.target.name = this.props.name;

            this.props.change(e);
        }

        /**
         *
         * @returns {*}
         */

    }, {
        key: 'render',
        value: function render() {
            var inputClasses = _inputField2.default['input-field'] + ' ' + _inputWithSelect2.default['input-with-select'] + ' ' + _inputWithSelect2.default.clearfix;

            if (this.props.disabled) {
                inputClasses += ' ' + _inputField2.default.disabled;
            }

            if (this.props.error) {
                inputClasses += ' ' + _inputWithSelect2.default.error;
            }

            var minimum = null,
                maximum = null,
                placeholder = this.props.placeholder;


            if (this.props.range) {
                var _props$range2 = this.props.range,
                    min = _props$range2.min,
                    max = _props$range2.max;


                if (!placeholder) {
                    if (min == null && max != null) placeholder = 'max. ' + max;else if (max == null && min != null) placeholder = 'min. ' + min;
                }

                if (!placeholder) placeholder = '(' + min + ' - ' + max + ')';

                if (min) {
                    minimum = parseRangeValue(min);
                }

                if (max) {
                    maximum = parseRangeValue(max);
                }
            }

            return _react2.default.createElement(
                'label',
                { className: inputClasses },
                _react2.default.createElement(
                    'span',
                    { className: _inputField2.default['label-container'], 'data-equalize': true },
                    _react2.default.createElement(
                        'span',
                        { className: _inputField2.default.label },
                        this.props.label
                    ),
                    this.props.showBadge ? _react2.default.createElement(
                        'span',
                        {
                            className: _inputField2.default.badge + (this.state.isBadgeActive ? ' ' + _inputField2.default['is-active'] : ''),
                            onMouseOver: this.onMouseover },
                        this.props.name
                    ) : null
                ),
                _react2.default.createElement(
                    'span',
                    { className: _inputWithSelect2.default['input-wrapper'] },
                    _react2.default.createElement('input', {
                        id: this.props.name + '-input',
                        onFocus: this.onFocus,
                        className: _inputField2.default.input,
                        value: this.state.value_1,
                        type: 'number',
                        placeholder: placeholder,
                        disabled: this.props.disabled,
                        onChange: this.handleValue,
                        required: this.props.required,
                        min: minimum,
                        max: maximum })
                ),
                _react2.default.createElement(
                    'span',
                    { className: _inputWithSelect2.default['select-wrapper'] },
                    _react2.default.createElement(
                        'select',
                        {
                            id: this.props.name + '-select',
                            onChange: this.handleValue,
                            onClick: function onClick(e) {
                                e.preventDefault();e.target.focus();return false;
                            },
                            onFocus: this.onFocus,
                            disabled: this.props.disabled,
                            value: this.state.value_2 },
                        _react2.default.createElement(
                            'option',
                            { disabled: true, value: '-1' },
                            this.props.pleaseChoose
                        ),
                        this.state.selectValues.map(function (option) {
                            return _react2.default.createElement(
                                'option',
                                { key: option.key,
                                    value: option.key },
                                option.label
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: _inputWithSelect2.default['error-message'] },
                    this.props.error ? this.props.error.label : ''
                )
            );
        }
    }]);

    return InputWithSelect;
}(_react2.default.Component);

/**
 * filter values of the select box to minimum and maximum
 *
 * @param list
 * @param props
 *
 * @returns {*}
 */


function filterSelectValues(list, props) {
    return list.filter(function (entry) {
        var localMin = void 0,
            localMax = void 0;

        var _props$range3 = props.range,
            min = _props$range3.min,
            max = _props$range3.max,
            key = entry.key;


        var parsedValue = parseInchString(key + '"');

        if (min) localMin = parseInchString(min + '"');
        if (max) localMax = parseInchString(max + '"');

        if (min && localMin > parsedValue) return false;
        if (max && localMax < parsedValue) return false;

        return true;
    });
}

InputWithSelect.propTypes = {
    change: _propTypes2.default.func,
    disabled: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    error: _propTypes2.default.object,
    id: _propTypes2.default.any,
    label: _propTypes2.default.string.isRequired,
    max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    name: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    required: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    type: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    showBadge: _propTypes2.default.bool,
    pleaseChoose: _propTypes2.default.string.isRequired,
    filterSelectToMinMax: _propTypes2.default.bool
};

InputWithSelect.defaultProps = {
    type: 'text',
    showBadge: true,
    filterSelectToMinMax: false
};

exports.default = InputWithSelect;


//////////////////
// WEBPACK FOOTER
// ./client/components/input-with-select/index.js
// module id = 491
// module chunks = 0